import req from 'utils/req';

export function fetchTopDestinations() {
  return req(
    `${URL_API_HOST}/api/v3/location-areas/top?include=location_area&desired_num_results=200`,
  ).get();
}

export function fetchCountries() {
  return req(`${URL_API_HOST}/api/v1/countries`).get();
}

export function fetchApprovedLocations() {
  return req(`${URL_API_HOST}/api/v1/locations/approved`).get();
}
